import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveCity() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((cityId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = cityId
      ? quarkusApi.put(`/city-catalog/${cityId}`, payload, authHeader)
      : quarkusApi.post('/city-catalog', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
